import { Getters } from 'vuex-smart-module';
import LeadsState from './state';

export default class OrganizationGetters extends Getters<LeadsState> {}
